import React, { useEffect, useState, useRef } from "react";
import { useParams, useLocation } from 'react-router-dom';
import FullscreenController from "../../utils/class.fullscreen_manager";
import { makeAPI } from "../../services/api";
// import EventLeaderboard from "./event_leaderboard";
import CountdownTimer from "../custom_hooks/timer";
import coin from '../../assets/img/icons/coin.avif';
import { getViteImage,showSuccess,showError,showInfo } from "../../utils/utils";

// import TournamentRegistrationPopup from "./tournament_registration_popup";

// SUB_ID NEED FOR CLICKING ACTION PARENT COMPONENT.
export default function GameJamDetails() {
    const fullscreenRef = useRef(null);
    const startDelayTimerRef = useRef(null);
    const tapCountdownTimerRef = useRef([]);
    const startEnableTimerRef = useRef(null);
    const isGameVisibleRef = useRef(false);
    const hasTapUnlockedRef = useRef(false);
    const lastOrientationRef = useRef("portrait");
    const [IframeHeight, setIframeHeight] = useState(600);
    const hasRun = useRef(false);
    const { event_id, game_id } = useParams();
    const user = JSON.parse(localStorage.getItem('user'));
    const user_id = user?.user_id;
    const [GamesData, setGamesData] = useState();
    const [Leaderboard_data, setLeaderboard_data] = useState([]);
    const [player_name, setplayer_name] = useState(user?.name);
    const [isStartingGame, setIsStartingGame] = useState(false);
    const [isGameVisible, setIsGameVisible] = useState(false);
    const [iframeSrc, setIframeSrc] = useState("");
    const [iframeSessionKey, setIframeSessionKey] = useState(0);
    const [showSlowStartText, setShowSlowStartText] = useState(false);
    const [showTapToPlayOverlay, setShowTapToPlayOverlay] = useState(false);
    const [tapCountdown, setTapCountdown] = useState(0);
    const [inputUnlocked, setInputUnlocked] = useState(false);
    const [isIOSClient, setIsIOSClient] = useState(false);
    const [isStartReady, setIsStartReady] = useState(true);
    const [voteChoice, setVoteChoice] = useState(null);
    const [likeCount, setLikeCount] = useState(0);
    const [dislikeCount, setDislikeCount] = useState(0);
    const [isFavourite, setIsFavourite] = useState(false);
    const [showVotePopup, setShowVotePopup] = useState(false);
    const [voteMessage, setVoteMessage] = useState("");
    const [playStartAt, setPlayStartAt] = useState(null);
    const [voteError, setVoteError] = useState("");
    const [CommentError, setCommentError] = useState("");
    const [user_voted, setuser_voted] = useState(false);
    const [unvoteReady, setUnvoteReady] = useState(false);
    const [unvoteRemainingMs, setUnvoteRemainingMs] = useState(0);
    const [TopVoters, setTopVoters] = useState([]);
    const [comment, setcomment] = useState("");
    const [commentCooldown, setCommentCooldown] = useState(false);
    const [ListCommands, setListCommands] = useState([]);
    const launchConfigRef = useRef(null);
    const unvoteTimerRef = useRef(null);
    const profile_pic = user?.profile_pic || 0;
    const location = useLocation();
    const { sub_id } = useParams();
    const PAGE_SIZE = 3;
    const [offset, setOffset] = useState(0); // skip
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [total, settotal] = useState(0);
    // const sub_id = location.state?.sub_id;
    // console.log("_______SUB ID______ ",sub_id)
    const isLandscapeMode = () => {
        if (window.matchMedia) return window.matchMedia("(orientation: landscape)").matches;
        return window.innerWidth > window.innerHeight;
    };

    const isTapRequiredForInitialLoad = () => {
        const raw = GamesData?.tap_required;
        if (typeof raw === "boolean") return raw;
        if (typeof raw === "number") return raw === 1;
        if (typeof raw === "string") return raw.toLowerCase() === "true" || raw === "1";
        return true;
    };

    const scheduleStartEnable = () => {
        if (isGameVisibleRef.current) return;
        if (!isIOSClient || !isLandscapeMode()) {
            setIsStartReady(true);
            return;
        }
        setIsStartReady(false);
        if (startEnableTimerRef.current) clearTimeout(startEnableTimerRef.current);
        startEnableTimerRef.current = setTimeout(() => {
            setIsStartReady(true);
        }, 3000);
    };

    const startTapCountdown = () => {
        setShowTapToPlayOverlay(true);
        setTapCountdown(3);
        tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
        tapCountdownTimerRef.current = [
            setTimeout(() => setTapCountdown(2), 1000),
            setTimeout(() => setTapCountdown(1), 2000),
            setTimeout(() => setTapCountdown(0), 3000)
        ];
    };

    const recoverIOSInputFocus = () => {
        const iframe = document.getElementById("game_frame");
        if (!iframe) return;
        setTimeout(() => {
            try {
                iframe.style.pointerEvents = "none";
                void iframe.offsetHeight;
                iframe.style.pointerEvents = "auto";
                iframe.focus();
                iframe.contentWindow?.focus();
            } catch (_) {
                // no-op
            }
        }, 260);
    };

    useEffect(() => {
        isGameVisibleRef.current = isGameVisible;
    }, [isGameVisible]);

    useEffect(() => {
        lastOrientationRef.current = isLandscapeMode() ? "landscape" : "portrait";
    }, []);

    useEffect(() => {
        if (isGameVisible) return;
        scheduleStartEnable();
        const onPrestartOrientation = () => {
            if (!isGameVisibleRef.current) scheduleStartEnable();
        };
        window.addEventListener("orientationchange", onPrestartOrientation);
        window.addEventListener("resize", onPrestartOrientation);
        return () => {
            window.removeEventListener("orientationchange", onPrestartOrientation);
            window.removeEventListener("resize", onPrestartOrientation);
        };
    }, [isIOSClient, isGameVisible]);


    // Initialize FullscreenController once
    useEffect(() => {
        fullscreenRef.current = new FullscreenController();
        const FSC = fullscreenRef.current;
        const os = FSC.getOS();
        setIsIOSClient(os === "iOS" || os === "iOS Tablet");

        // Handle orientation change for iOS
        const handleOrientationChange = () => {
            const OS = FSC.getOS();
            if (OS === "iOS" || OS === "iOS Tablet") {
                FSC.onOrientationChange(GamesData?.orientation || "landscape");
                if (isGameVisibleRef.current) {
                    const required = GamesData?.orientation || "landscape";
                    const current = FSC.DeduceOrientation?.() || "portrait";
                    const isCorrectOrientation = required === current;
                    const prevOrientation = lastOrientationRef.current;
                    lastOrientationRef.current = current;
                    if (isCorrectOrientation) {
                        // iOS: after returning to landscape, force a fresh user tap unlock.
                        setTimeout(() => {
                            setInputUnlocked(false);
                            startTapCountdown();
                        }, prevOrientation === "portrait" ? 350 : 120);
                    } else {
                        setInputUnlocked(false);
                        setShowTapToPlayOverlay(false);
                        setTapCountdown(0);
                    }
                }
                if (!isGameVisibleRef.current) scheduleStartEnable();
            }
        };

        window.addEventListener("orientationchange", handleOrientationChange);
        window.addEventListener("resize", handleOrientationChange);
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", handleOrientationChange);
        }

        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
            window.removeEventListener("resize", handleOrientationChange);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener("resize", handleOrientationChange);
            }
        };
    }, [GamesData?.orientation]);

    useEffect(() => {
        scheduleStartEnable();
    }, [isIOSClient]);

    // Fallback: if iOS is back in valid orientation and input is still locked, force tap overlay.
    useEffect(() => {
        if (!isIOSClient || !isGameVisible) return;
        const required = GamesData?.orientation || "landscape";
        const current = fullscreenRef.current?.DeduceOrientation?.() || "portrait";
        const isCorrectOrientation = required === current;
        if (!isCorrectOrientation) return;
        if (inputUnlocked) return;
        if (showTapToPlayOverlay) return;

        const timer = setTimeout(() => {
            setInputUnlocked(false);
            startTapCountdown();
        }, 500);

        return () => clearTimeout(timer);
    }, [isIOSClient, isGameVisible, inputUnlocked, showTapToPlayOverlay, GamesData?.orientation, iframeSessionKey]);

    // Handle fullscreen exit event
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement && fullscreenRef.current) {
                handleGameExit(false);
            }
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // Calculate iframe height based on screen size
    useEffect(() => {
        const calculateIframeHeight = () => {
            const isMobile = window.innerWidth < 768;
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            const windowHeight = Math.max(viewportHeight, 400);
            const Getdevice_info = fullscreenRef.current?.getOS() || {};
            if (isMobile) {
                setIframeHeight(windowHeight);
            } else {
                if (Getdevice_info === "iOS" || Getdevice_info === "iOS Tablet" || Getdevice_info === "Android" || Getdevice_info === "Android Tablet") {
                    setIframeHeight(windowHeight);
                } else {
                    setIframeHeight(600);
                }
            }
        };

        calculateIframeHeight();
        window.addEventListener('resize', calculateIframeHeight);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', calculateIframeHeight);
        }

        return () => {
            window.removeEventListener('resize', calculateIframeHeight);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', calculateIframeHeight);
            }
        };
    }, []);

    // Fetch tournament and game data
    useEffect(() => {
        document.title = "Tournament Information - CGES.CLUB";

        if (hasRun.current) return;
        hasRun.current = true;
        const fetchAllData = async () => {
            try {
                await Promise.all([
                    // get_tournament_list(event_id, game_id),
                    get_comment_list(offset),
                    get_game_info(game_id),
                    // LeaderBoardData(game_id, event_id)
                ]);
                setplayer_name(user?.name);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                //Gracefully completed
            }
        };

        fetchAllData();
    }, [event_id, game_id]);

    useEffect(() => {
        // Reset game frame when route/game changes so stale SDK session is not reused.
        setIsGameVisible(false);
        setIframeSrc("");
        setIframeSessionKey(prev => prev + 1);
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);
        setInputUnlocked(false);
        hasTapUnlockedRef.current = false;
        setIsStartingGame(false);
        setShowSlowStartText(false);
        launchConfigRef.current = null;
        scheduleStartEnable();
    }, [event_id, game_id]);

    useEffect(() => {
        return () => {
            if (startDelayTimerRef.current) {
                clearTimeout(startDelayTimerRef.current);
                startDelayTimerRef.current = null;
            }
            if (startEnableTimerRef.current) {
                clearTimeout(startEnableTimerRef.current);
                startEnableTimerRef.current = null;
            }
            tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
            tapCountdownTimerRef.current = [];
            if (unvoteTimerRef.current) {
                clearTimeout(unvoteTimerRef.current);
                unvoteTimerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (isGameVisible && !playStartAt) {
            setPlayStartAt(Date.now());
        }
        if (!isGameVisible) {
            setPlayStartAt(null);
        }
    }, [isGameVisible, playStartAt]);

    useEffect(() => {
        if (!voteError) return;
        const timer = setTimeout(() => setVoteError(""), 2500);
        return () => clearTimeout(timer);
    }, [voteError]);

    const getVoteAtKey = () => {
        const sub = GamesData?.sub_id ?? GamesData?.game_id;
        return sub ? `gamejam_vote_at_${sub}` : null;
    };

    useEffect(() => {
        if (!user_voted) {
            setUnvoteReady(false);
            setUnvoteRemainingMs(0);
            if (unvoteTimerRef.current) {
                clearInterval(unvoteTimerRef.current);
                unvoteTimerRef.current = null;
            }
            return;
        }
        const key = getVoteAtKey();
        if (!key) return;
        const stored = Number(localStorage.getItem(key));
        if (!Number.isFinite(stored)) {
            localStorage.setItem(key, String(Date.now()));
        }

        const update = () => {
            const voteAt = Number(localStorage.getItem(key));
            const elapsed = Date.now() - voteAt;
            const waitMs = 2 * 60 * 1000;
            const remaining = Math.max(0, waitMs - elapsed);
            setUnvoteRemainingMs(remaining);
            setUnvoteReady(remaining === 0);
        };

        update();
        if (unvoteTimerRef.current) clearInterval(unvoteTimerRef.current);
        unvoteTimerRef.current = setInterval(update, 1000);

        return () => {
            if (unvoteTimerRef.current) {
                clearInterval(unvoteTimerRef.current);
                unvoteTimerRef.current = null;
            }
        };
    }, [user_voted, GamesData?.sub_id, GamesData?.game_id]);

    useEffect(() => {
        if (!CommentError) return;
        const timer = setTimeout(() => CommentError(""), 2500);
        return () => clearTimeout(timer);
    }, [CommentError]);

    // iOS safety gate: block all early touches/clicks until tap-to-play unlocks input.
    useEffect(() => {
        if (!isIOSClient || !isGameVisible || inputUnlocked) return;

        const container = document.getElementById("iframe-div");
        if (!container) return;

        const blockEvent = (e) => {
            const target = e.target;
            if (target?.closest?.("[data-allow-input='1']")) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
        };

        const nonPassiveCapture = { capture: true, passive: false };
        const captureOnly = true;

        const touchEvents = ["touchstart", "touchmove", "touchend", "touchcancel"];
        const pointerEvents = ["pointerdown", "pointermove", "pointerup", "pointercancel", "click"];

        touchEvents.forEach((eventName) => container.addEventListener(eventName, blockEvent, nonPassiveCapture));
        pointerEvents.forEach((eventName) => container.addEventListener(eventName, blockEvent, captureOnly));

        return () => {
            touchEvents.forEach((eventName) => container.removeEventListener(eventName, blockEvent, nonPassiveCapture));
            pointerEvents.forEach((eventName) => container.removeEventListener(eventName, blockEvent, captureOnly));
        };
    }, [isIOSClient, isGameVisible, inputUnlocked, iframeSessionKey]);

    const handleGameExit = (forceExit = false) => {
        const os = fullscreenRef.current?.getOS();
        const isMobileOrTab =
            os === "iOS" ||
            os === "iOS Tablet" ||
            os === "Android" ||
            os === "Android Tablet";

        fullscreenRef.current?.ExitFullscreen({ forceExit });
        if (startDelayTimerRef.current) {
            clearTimeout(startDelayTimerRef.current);
            startDelayTimerRef.current = null;
        }
        tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
        tapCountdownTimerRef.current = [];
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);
        setInputUnlocked(false);
        hasTapUnlockedRef.current = false;
        setIsStartingGame(false);
        setShowSlowStartText(false);
        scheduleStartEnable();

        if (isMobileOrTab) {
            // Mobile/Tab: return to banner state
            setIsGameVisible(false);
            setIframeSrc("");
            setIframeSessionKey((k) => k + 1);
            launchConfigRef.current = null;
            return;
        }

        // Desktop: keep iframe/game as-is
        // no state reset here
    };


    // Run fullscreen init only after iframe is mounted in DOM.
    useEffect(() => {
        if (!isGameVisible || !iframeSrc) return;
        if (!fullscreenRef.current) return;
        if (!launchConfigRef.current) return;

        fullscreenRef.current.func_int(launchConfigRef.current);
    }, [isGameVisible, iframeSrc, iframeSessionKey]);


    const get_game_info = async (game_id) => {
        try {
            let GameInfo = await makeAPI('/api/gamejam_details', 'post', false, { user_id: user_id, sub_id: sub_id });
            if (GameInfo.status === "S") {
                setGamesData(GameInfo?.data);
                // setuser_voted(GameInfo?.isVoted); // Set voting status based on API response
                setTopVoters(GameInfo?.top_3_voters);
            } else {

            }
            setuser_voted(GameInfo?.isvoted);
        } catch (error) {
            console.error(error);
        }
    };

    const get_comment_list = async (newOffset) => {
        if (loading) return;
        setLoading(true);
        try {
            let GameInfo = await makeAPI('/api/gamejam_comment_listing', 'post', false, { user_id: user_id, sub_id: sub_id, offset: newOffset, limit: PAGE_SIZE });
            if (GameInfo.status === "S") {
                setListCommands(prev => [...prev, ...GameInfo.data]);
                setOffset(newOffset + PAGE_SIZE);
                setHasMore(GameInfo.hasMore);
                settotal(GameInfo.total)
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error(error);
        } finally {

            setLoading(false);

        }
    }
    const handleLoadMore = () => {
        get_comment_list(offset);
    };
    const PlayGame = async () => {

        if (isStartingGame) return;

        if (!GamesData) return;
        if (isIOSClient && !isStartReady) return;
        setIsStartingGame(true);
        setShowSlowStartText(false);
        if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
        startDelayTimerRef.current = setTimeout(() => {
            setShowSlowStartText(true);
        }, 3000);
        try {

            const login_status = await CheckLoginStatus();
            if (!login_status) {
                if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
                setIsStartingGame(false);
                setShowSlowStartText(false);
                return;
            }
            const startedInternal = LoadIframe();
            if (!startedInternal) {
                if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
                setIsStartingGame(false);
                setShowSlowStartText(false);
                scheduleStartEnable();
            }
        } catch (_) {
            if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
            setIsStartingGame(false);
            setShowSlowStartText(false);
            scheduleStartEnable();
        }
    };
    const readPlayStart = () => {
        const key = `gamejam_play_start_${GamesData?.game_id}`
        if (!key) return null;
        try {
            const stored = localStorage.getItem(key);
            const parsed = stored ? Number(stored) : null;
            setPlayStartAt(parsed);
            return Number.isFinite(parsed) ? parsed : null;
        } catch (_) {
            return null;
        }
    };
    const handleVote = (type) => {
        if (type !== "like" && type !== "dislike") return;
        if (voteChoice === type) {
            setVoteChoice(null);
            if (type === "like") setLikeCount((c) => Math.max(0, c - 1));
            if (type === "dislike") setDislikeCount((c) => Math.max(0, c - 1));
            return;
        }
        if (voteChoice === "like") setLikeCount((c) => Math.max(0, c - 1));
        if (voteChoice === "dislike") setDislikeCount((c) => Math.max(0, c - 1));
        setVoteChoice(type);
        if (type === "like") setLikeCount((c) => c + 1);
        if (type === "dislike") setDislikeCount((c) => c + 1);
    };

    const canVoteNow = () => {
        if(!user){return OpenModal()}
          
        // check vote start date .
        


        const startTs = readPlayStart();
        // console.log("startTs", startTs);
        // if (startTs > 0) return false;
         if (!startTs) return false;
         console.log("Can i vote ?",Date.now() - startTs >= 2 * 60 * 1000)
        return Date.now() - startTs >= 2 * 60 * 1000;
    };

    const handleOpenVote = () => {

        // if (!isGameVisible) {
        //     setVoteError("Please start the game before voting.");
        //     return;
        // }
        let user = JSON.parse(localStorage.getItem('user'));
        if(!user){return OpenModal()}
        if (!canVoteNow()) {
            showError("Please play the game for at least 2 minutes before voting.");
            setVoteError("Please play at least 2 minutes before voting.");
            return;
        }
            // console.log("Vote Starting Date is",new Date(gamejam ?.vote_start_dt).getTime());

        // check also Vote submission date is start or not.
        if (GamesData?.voting_stat === false) {
            const now = Date.now();
            const voteStartTime = new Date(GamesData?.vote_start_time).getTime();
            const voteEndTime = new Date(GamesData?.vote_end_time).getTime();

            if (voteEndTime <= now) {
                showError("Voting has ended.");
                setVoteError(`Voting ended on ${new Date(voteEndTime).toLocaleString()}`);
            } else if (voteStartTime > now) {
                showError("Voting has not started yet. Please come back later.");
                setVoteError("Voting has not started yet.");
            } else {
                setVoteError("");
                setShowVotePopup(true);
            }
            return;
        }
        setVoteError("");
        setShowVotePopup(true);
    };

    const handleSubmitVote = async () => {
        if (!voteMessage.trim()) {
            showInfo("Please tell us what you like about the game.");
            setVoteError("Please tell us what you like about the game.");
            return;
        }
        setVoteError("");
        // console.log("Vote feedback:", { message: voteMessage.trim(), game_id, event_id });

        // submit the feedback .

        const targetSubId = GamesData?.game_id || sub_id;
        let submit_feedback = await makeAPI('/api/gamejam_voting', 'post', false, { user_id: user_id, sub_id: targetSubId, feedback: voteMessage.trim() });
        if (submit_feedback.status === "S") {
            setShowVotePopup(false);
            setVoteMessage("");
            setPlayStartAt(null);
            setuser_voted(true);
            const key = getVoteAtKey();
            if (key) {
                localStorage.setItem(key, String(Date.now()));
            }
        } else {
            alert(submit_feedback?.message);
            showInfo("Only Can Vote Active GameJam");
            setShowVotePopup(false);

        }
    };

    const handleUnvote = async () => {
        let user = JSON.parse(localStorage.getItem('user'));
        if(!user){return OpenModal()}
        setVoteError("");
        const targetSubId = GamesData?.game_id || sub_id;
        let unvote = await makeAPI('/api/gamejam_voting', 'post', false, { user_id: user_id, sub_id: targetSubId, action: "unvote" });
        if (unvote.status === "S") {
            setuser_voted(false);
            const key = getVoteAtKey();
            if (key) localStorage.removeItem(key);
        } else {
            showError(unvote?.message || "Unable to remove vote.");
            setVoteError(unvote?.message || "Unable to remove vote.");
        }
    };
    const getPlayStorageKey = (key) => {
        // check if key is there or not.
        let check = localStorage.getItem(key);
        if (check) {
            return true;
        }
        return false;
    };

    const LoadIframe = () => {
        const key = `gamejam_play_start_${GamesData?.game_id}`;
        const stat = getPlayStorageKey(key);
        if (!stat) {
            localStorage.setItem(key, JSON.stringify(Date.now()));
        }
        if (!fullscreenRef.current) return;
        const FSC = fullscreenRef.current;
        const GetOS = FSC.getOS();
        const orientation = GamesData?.orientation || "landscape";

        // check if External Game or Internal Game:
        if (GamesData?.hosting_type === "external") {

            if (GetOS === "Unknown") {
                window.open(GamesData?.game_urls?.desktop_url);
                return false;
            }
            if (GetOS === "iOS" || GetOS === "iOS Tablet") {
                window.open(GamesData?.game_urls?.ios_url);
                return false;
            }
            window.open(GamesData?.game_urls?.mobile_url);
            return false;
        }

        // Ensure Orientation and Game Orientation are same for iOS devices before loading iframe.
        if ((GetOS === "iOS" || GetOS === "iOS Tablet") && orientation !== FSC.DeduceOrientation()) {

            alert("Please rotate your device to " + orientation + " mode to play the game.");
            // console.log("LoadIframe - Orientation mismatch for iOS device");
            return false;
        }


        // console.log("LoadIframe - OS:", GetOS, "Orientation:", orientation);

        // Common setup for all platforms
        setIframeSrc(GamesData?.game_urls?.desktop_url);
        setIframeSessionKey(prev => prev + 1);
        setIsGameVisible(true);
        setInputUnlocked(false);
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);

        // Defer fullscreen init until iframe is mounted.
        launchConfigRef.current = { GetOS, orientation };

        // Show bottom strip for desktop
        if (GetOS === "Unknown") {
            // bottom strip is controlled by state-driven render.
        }
        // console.log("6")

        return true;
    };

    const handleTapToPlay = () => {
        if (tapCountdown > 0) return;
        setShowTapToPlayOverlay(false);
        setInputUnlocked(true);
        hasTapUnlockedRef.current = true;
        const iframe = document.getElementById("game_frame");
        iframe?.focus();
        iframe?.contentWindow?.focus();
        recoverIOSInputFocus();
    };

    const CheckLoginStatus = async () => {
        let status = false;
        // currently using Localstorage Data. later on using share context.
        const user_id_ = JSON.parse(localStorage.getItem('user'));
        if (user_id_?.user_id) {
            status = true;
        } else {

            // depends on game (Intenal set time out to play a game) else return false;
            console.log("SET THE TIME INTERVAL OF GAME TO PLAY AND STOP .")
            // const OpenModal = () => {
            //     if (window.UIkit && typeof window.UIkit.modal === "function") {
            //         window.UIkit.modal("#modal-login", { container: false }).show();
            //     }
            // };
            // OpenModal();
            status = true;
        }
        return status;
    };

    const handleTimerEnd = async () => {
        setTournamentList(prev => {
            const updated = [...prev];
            updated[0].tournament_status = "completed";
            return updated;
        });

        // setTimerEnded(prev => !prev); // Toggle to trigger re-render
    };
    const handleShare = async () => {

        if (navigator.share) {
            try {
                await navigator.share({
                    title: "GameJam",
                    text: "Check this game!",
                    url: window.location.href
                });
            } catch (err) {
                console.log(err);
            }
        } else {
            navigator.clipboard.writeText(window.location.href);
            // alert("Link copied to clipboard!");
            showInfo("Link copied to clipboard!");
        }

    };
    const SubmitComment = async (event) => {
        event.preventDefault();
        if (!user) { return OpenModal(); }

        if (comment.trim().length === 0) {
            setCommentError("Please enter a comment. !");
            return;
        }
        setCommentError("");


        try {
            let data = {
                sub_id: sub_id,
                gamejam_id: GamesData?.gamejam_id,
                user_id: user_id,
                comment: comment,
            }
            let submit_comment = await makeAPI('/api/gamejam_comment_submit', 'post', false, data);
            if (submit_comment.status === "S") {
                // comment successfully after 15 sec button will until buton will disable timeout enable.
                // alert("submiited comment successfully");
                showSuccess("submited comment successfully");
                let temp_data ={ // for sudden ui enable comment.
                    _id: submit_comment?.ref || new Date(),
                    game_id: event_id,
                    profile_pic: user?.profile_pic || 0,
                    name:user?.name,
                    img_url:user?.img_url || "",
                    sub_id: sub_id,
                    user_id: user?.user_id,
                    comment: comment,
                    crd_on: new Date(),
                    stat: 'A'
                }
                setListCommands((prev)=> [temp_data,...prev]);
                setcomment("");
                setCommentCooldown(true);  // Start cooldown
                setTimeout(() => {
                    setCommentCooldown(false);  // End cooldown after 15 seconds
                }, 5000);

            } else {
                // alert("not comment save")
                showError("Check your Comment !");
                setcomment("");
                setCommentCooldown(true);  // Start cooldown
                setTimeout(() => {
                    setCommentCooldown(false);  // End cooldown after 15 seconds
                }, 5000);
            }
        } catch (error) {
            console.error("Error submitting comment:", error);
            setcomment("");
            setCommentCooldown(true);  // Start cooldown even on error to prevent spamming
            setTimeout(() => {
                setCommentCooldown(false);  // End cooldown after 15 seconds
            }, 5000);
        }
    }

    const handleDelete  = async (data) =>{
        // console.log("_ID",data);
        try {
            let delete_comment = await makeAPI('/api/gamejam_comment_submit','post',false,{ref_id:data});
            if(delete_comment.status === "S"){
                // alert("delete comment successfully");
                showSuccess("delete comment successfully");
                // remove from the state.
                setListCommands(prev => prev.filter(comment => comment._id !== data));
            }
        } catch (error) {
            console.log("ERROR",error)
        }
    }
    return (
        <>

            {/* {registration_popup ? <TournamentRegistrationPopup onRegister={RegisterTournament} onClose={() => { setregistration_popup(false) }} game_id={Number(game_id)} game_name={GamesData?.game_name} event_id={event_id} /> : null} */}

            <div id="rotate-overlay" className="rotate-overlay">
                <div className="rotate-box">
                    <p><i className="fa-solid fa-rotate" style={{ color: "var(--main-color-one)" }}></i> Rotate your device</p>
                    <small>This game works in {GamesData?.orientation || "landscape"} mode</small>
                </div>
            </div>

           
            <div className="uk-grid uk-grid-custom" data-uk-grid="">
                <div className="uk-width-3-4@l uk-width-3-5@m">
                    <div className="uk-grid uk-child-width-2-2@l uk-child-width-2-2@m uk-child-width-1-1@s">
                        <section className="b-post b-post-full b-post-single clearfix">
                            <div className="entry-media">
                                  <p className='' style={{ backgroundColor: "transparent", cursor: "pointer" }} onClick={() => {
                window.history.back();
            }}><i className="fa-solid fa-arrow-left"></i> {"BACK"}</p>
                                {!isGameVisible ? (

                                    <img className="img-fluid" src={GamesData?.banner_img_url || getViteImage('fallback/gameplayer.jpg')}
                                        id="img_frame" alt="Game Thumbnail" style={{ opacity: "0.5" }} />
                                ) : null}

                                {
                                    GamesData?.hosting_type === "internal" ? (
                                        <>
                                            <div id="iframe-div" style={{ display: isGameVisible ? 'block' : 'none' }}>
                                                <div
                                                    id='float_button'
                                                    data-allow-input='1'
                                                    style={{
                                                        top: "15px",
                                                        left: "0px",
                                                        position: "absolute",
                                                        display: "none",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0px 30px 30px 0px",
                                                        backgroundColor: "#ffffff",
                                                        height: "40px",
                                                        opacity: "0.8",
                                                        padding: "0 15px",
                                                        zIndex: "9999",
                                                        cursor: "pointer",
                                                        fontWeight: "bold",
                                                        fontSize: "14px",
                                                        color: "#000"
                                                    }}
                                                    onClick={() => handleGameExit(true)}
                                                >
                                                    Exit
                                                </div>

                                                {isGameVisible && iframeSrc ? (
                                                    <iframe
                                                        key={iframeSessionKey}
                                                        height={IframeHeight || 600}
                                                        width="100%"
                                                        id='game_frame'
                                                        src={iframeSrc}
                                                        name='iframe_a'
                                                        title={GamesData?.game_name}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: isIOSClient && isGameVisible ? '0px' : '10px 10px 0px 0px',
                                                            pointerEvents: isIOSClient && !inputUnlocked ? "none" : "auto"
                                                        }}
                                                        scrolling="no"
                                                        frameBorder="0"
                                                        tabIndex={0}
                                                        allowFullScreen
                                                        onLoad={() => {
                                                            if (startDelayTimerRef.current) {
                                                                clearTimeout(startDelayTimerRef.current);
                                                                startDelayTimerRef.current = null;
                                                            }
                                                            setIsStartingGame(false);
                                                            setShowSlowStartText(false);
                                                            if (!isIOSClient) {
                                                                setInputUnlocked(true);
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                return;
                                                            }
                                                            setInputUnlocked(false);
                                                            const orientation = GamesData?.orientation || "landscape";
                                                            const isCorrectOrientation = orientation === (fullscreenRef.current?.DeduceOrientation?.() || "portrait");
                                                            if (!isCorrectOrientation) {
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                return;
                                                            }
                                                            if (isTapRequiredForInitialLoad()) {
                                                                startTapCountdown();
                                                            } else {
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                setInputUnlocked(true);
                                                                recoverIOSInputFocus();
                                                            }
                                                        }}
                                                    />
                                                ) : null}

                                                {isGameVisible && isIOSClient && showTapToPlayOverlay ? (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            zIndex: 10010,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            background: "rgba(0,0,0,0.45)"
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            data-allow-input='1'
                                                            className="btn text-white"
                                                            style={{
                                                                backgroundColor: tapCountdown > 0 ? "transparent" : " #ff810e",
                                                                minWidth: "220px",
                                                                minHeight: "56px",
                                                                borderRadius: "12px",
                                                                fontSize: "20px",
                                                                fontWeight: 700
                                                            }}
                                                            onClick={handleTapToPlay}
                                                        >
                                                            {tapCountdown > 0 ? `Please wait ... ${tapCountdown}` : "Tap Screen To Play"}
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div
                                                className="bottom-strip"
                                                style={{
                                                    backgroundColor: '#222',
                                                    padding: '5px 10px',
                                                    marginTop: '0px',
                                                    borderRadius: '0px 0px 10px 10px',
                                                    // display: isGameVisible && !isIOSClient ? "block" : "none"
                                                    display: "block"
                                                }}
                                            >
                                                <div className="row align-items-center" style={{ padding: '0px 5px' }}>
                                                    <div className="col-12 col-sm-12">
                                                        <div className='row'>
                                                            <div className='d-flex justify-content-between align-items-center flex-wrap' style={{ gap: "8px" }}>
                                                                <div className="logo-aligned">
                                                                    {/* <img src="../images/cg_logo_white.png" width="30" alt="Logo" /> */}
                                                                    <span style={{ maxWidth: "150px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} className='game_name_footer'>{GamesData?.game_name.toUpperCase()}</span>
                                                                </div>

                                                                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                                    {/* <button
                                                                        title="Like"
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onClick={() => handleVote("like")}
                                                                        style={{
                                                                            backgroundColor: voteChoice === "like" ? "#2dba4e" : "transparent",
                                                                            color: "#fff",
                                                                            border: "1px solid #444"
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-thumbs-up" aria-hidden="true" /> {likeCount}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        title="Dislike"
                                                                        className="btn btn-sm"
                                                                        onClick={() => handleVote("dislike")}
                                                                        style={{
                                                                            backgroundColor: voteChoice === "dislike" ? "#d64545" : "transparent",
                                                                            color: "#fff",
                                                                            border: "1px solid #444"
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-thumbs-down" aria-hidden="true" /> {dislikeCount}
                                                                    </button> */}
                                                                    {/* <button
                                                                        title="Votes"
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onClick={() => setIsFavourite((v) => !v)}
                                                                        style={{
                                                                            backgroundColor: isFavourite ? "#ff810e" : "transparent",
                                                                            color: "#fff",
                                                                            border: "1px solid #444"
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-heart" aria-hidden="true" /> &nbsp; {GamesData?.votes || 0}
                                                                    </button> */}
                                                                    <div
                                                                        style={{ textAlign: 'right' }}
                                                                        onClick={() => {
                                                                            if (!isGameVisible) return;
                                                                            fullscreenRef.current?.EnterFullscreen('landscape');
                                                                        }}
                                                                        title={isGameVisible ? "Fullscreen" : "Start game to enable fullscreen"}
                                                                    >
                                                                        <span
                                                                            title='Fullscreen'
                                                                            className="icon fa fa-2x fa-expand"
                                                                            style={{
                                                                                fontSize: "15px",
                                                                                color: "#fff",
                                                                                fontWeight: "bolder",
                                                                                cursor: isGameVisible ? 'pointer' : 'not-allowed',
                                                                                opacity: isGameVisible ? 1 : 0.4
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null
                                }

                                <button className="fl-gp-button" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-40%, -40%)", color: "#fff", backgroundColor: "var(--main-color-one)", padding: "15px 22px", border: "none", textAlign: "center", borderRadius: "33px", display: isGameVisible && !isStartingGame ? "none" : "inline-flex", alignItems: "center", gap: "8px", opacity: isStartingGame ? 0.85 : 1, cursor: isStartingGame ? "not-allowed" : "pointer" }}
                                    id="start-btn"
                                    disabled={isStartingGame || (isIOSClient && !isStartReady)}
                                    onClick={() => { PlayGame() }}
                                >
                                    {isStartingGame ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            {showSlowStartText ? "Loading build... please wait" : "Starting game..."}
                                        </>
                                    ) : (isIOSClient && !isStartReady) ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            Preparing game...
                                        </>
                                    ) : "Play Game"}
                                </button>
                            </div>
                            <div className="entry-main ">
                                {GamesData ? (

                                    <React.Fragment>
                                        <hr />
                                        {user_voted && <span className="d-flex justify-content-center" style={{ color: "var(--main-color-one)" }}>Thanks for voting !</span>}<br />
                                        <div className="d-flex align-items-center justify-content-center flex-grow-1 gap-3" style={{ minWidth: "140px" }}>

                                            {GamesData?.gamejam_user === user_id ? (

                                                ""

                                            ) : user_voted ? (

                                                <button
                                                    type="button"
                                                    className="gj-action-btn gj-action-btn--ghost"
                                                    onClick={handleUnvote}
                                                    disabled={!unvoteReady}
                                                >
                                                    <i className="fas fa-thumbs-down"></i> {unvoteReady ? "Remove vote" : `Remove vote in ${formatRemaining(unvoteRemainingMs)}`}
                                                </button>

                                            ) : (

                                                // User can vote
                                                <button
                                                    type="button"
                                                    className="gj-action-btn"
                                                    onClick={handleOpenVote}
                                                >
                                                    <i className="fas fa-thumbs-up"></i> Vote
                                                </button>

                                            )}

                                            <button
                                                type="button"
                                                className="gj-action-btn"
                                                onClick={handleShare}
                                            >
                                                <i className="fas fa-share"></i> Share
                                            </button>
                                        </div>
                                        <div className="entry-content" id="">
                                            <div className="gj-details">
                                                <div className="gj-details-grid">
                                                    <section className="gj-detail-card">
                                                        <h4 className="tt-uppercase mb-2">Description</h4>
                                                        <p className="gj-detail-text" style={{overflowWrap:"anywhere"}}>{GamesData.description}</p>
                                                    </section>

                                                    <section className="gj-detail-card">
                                                        <h4 className="tt-uppercase mb-2">Instructions</h4>
                                                        <p className="gj-detail-text" style={{overflowWrap:"anywhere"}}>{GamesData.controls}</p>
                                                    </section>
                                                </div>

                                                <section className="gj-detail-card gj-detail-comments">
                                                    <div className="gj-detail-header">
                                                        <h4 className="tt-uppercase mb-0">Comments</h4>
                                                    </div>
                                                    <form onSubmit={SubmitComment}>
                                                        <div className="uk-width-1-1">
                                                            <small className="gj-muted">Add a comment</small>
                                                            <textarea
                                                                className="uk-textarea bg-transparent text-white mt-1 mb-1"
                                                                rows="2"
                                                                maxLength={250}
                                                                value={comment}
                                                                style={{ border: "1px solid #3d3d3d", height: "50px", width: "100%", resize: "block" }}
                                                                onChange={(e) => setcomment((prev) => (e.target.value))}
                                                            ></textarea>
                                                            {CommentError ? <div className="gj-error">{CommentError}</div> : null}
                                                        </div>
                                                        <div className="gj-comment-submit">
                                                            <button id="comment-submit-button" className="gj-action-btn gj-action-btn--compact" type="submit" disabled={commentCooldown ? true : false}>
                                                                {commentCooldown ? (
                                                                    <div className="spinner-border spinner-border-sm" role="status">
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </div>
                                                                ) : "submit comment"}
                                                            </button>
                                                        </div>
                                                    </form>
                                                    {ListCommands.length !== 0 ? (
                                                        <div className="comment-box">
                                                            {ListCommands.map((item) => (
                                                                <div key={item._id} className="comment-item">
                                                                    <img
                                                                        src={item?.img_url ? item.img_url : getViteImage(`profile_avatar/${item.profile_pic}.avif`)}
                                                                        alt="avatar"
                                                                        className="comment-avatar"
                                                                    />

                                                                    <div className="comment-content">
                                                                        <div className="comment-header">
                                                                            <span className="comment-name ">
                                                                            <span 
                                                                            className="d-block d-sm-flex"
                                                                            style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",width:"150px"}}
                                                                            >{item.name}</span><span className="comment-time">
                                                                                {formatTime(item.crd_on)}
                                                                            </span>
                                                                            </span>
                                                                            {/* Show delete only for owner */}
                                                                            {item?.user_id === user?.user_id && (
                                                                                <button
                                                                                    className="delete-btn"
                                                                                    onClick={() => handleDelete(item._id)}
                                                                                >
                                                                                    <i className="fa-solid fa-trash"></i> 
                                                                                    <span className="d-none d-sm-inline ms-1">Delete</span>
                                                                                </button>
                                                                            )}
                                                                        </div>

                                                                        <p className="comment-text" style={{overflowWrap:"anywhere"}}>{item.comment}</p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            {/* {hasMore && ( */}
                                                                <div className="comment-footer">
                                                                    <span className="load-more mt-1" 
                                                                    style={{cursor:hasMore ? "pointer":"default",textDecoration:hasMore ? "underline":"none"}}
                                                                    onClick={hasMore ?handleLoadMore:null}>
                                                                        {loading ? "Loading..." : hasMore ? "Load More" : "All Loaded..."}
                                                                    </span>
                                                                </div>
                                                            {/* )} */}
                                                        </div>

                                                    ) : null}
                                                </section>
                                            </div>
                                        </div>

                                    </React.Fragment>

                                ) : null}
                            </div>
                        </section>
                    </div>
                </div>
                <div className="uk-width-1-5@l uk-width-2-5@m">

                    <aside className="l-sidebar">

                        <section className="widget section-sidebar bg-light d-none d-lg-block">
                            <h3 className="widget-title bg-dark"><i className="ic icon-list"></i>Top Voting Games  &nbsp;&nbsp;
                            </h3>

                            <table className="table table-dark">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Game Name</th>
                                        <th>Votes</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {TopVoters?.length > 0 ? (
                                        TopVoters.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.rank ?? index + 1}</td>
                                                <td style={{ textOverflow: "ellipsis", overflow: "hidden", maxWidth: "150px", whiteSpace: "nowrap" }}>
                                                    {item.gamejam_title}
                                                </td>
                                                {/* <td><img src={coin} width={15} height={15} />&nbsp;{item.gamejam_vote}</td> */}
                                                <td>{item.gamejam_vote}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                                No games found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </section>



                    </aside>
                </div>
            </div>

            {showVotePopup ? (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.65)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10050,
                        padding: "16px"
                    }}
                    onClick={() => setShowVotePopup(false)}
                >
                    <div
                        style={{
                            background: "#1e1e1e",
                            color: "#fff",
                            width: "100%",
                            maxWidth: "420px",
                            borderRadius: "12px",
                            padding: "16px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.35)"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h5 style={{ marginBottom: "8px" }}>What would you like about the game?</h5>
                        <textarea
                            value={voteMessage}
                            onChange={(e) => setVoteMessage(e.target.value)}
                            rows={4}
                            maxLength={200}
                            style={{
                                width: "100%",
                                background: "#111",
                                color: "#fff",
                                border: "1px solid #333",
                                borderRadius: "8px",
                                padding: "8px"
                            }}
                            placeholder="Share your feedback..."
                        />
                        {voteError ? (
                            <div style={{ color: "#ff6b6b", marginTop: "6px", fontSize: "13px" }}>
                                {voteError}
                            </div>
                        ) : null}
                        <div className="d-flex justify-content-end" style={{ gap: "8px", marginTop: "12px" }}>
                            <button
                                type="button"
                                className="gj-action-btn gj-action-btn--ghost"
                                onClick={() => setShowVotePopup(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="gj-action-btn"
                                onClick={async () => { await handleSubmitVote() }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}

            {voteError && !showVotePopup ? (
                <div
                    style={{
                        position: "fixed",
                        bottom: "24px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#2b2b2b",
                        color: "#fff",
                        padding: "8px 14px",
                        borderRadius: "999px",
                        zIndex: 10060,
                        fontSize: "13px",
                        border: "1px solid #444"
                    }}
                >
                    {voteError}
                </div>
            ) : null}
            <style>{`
            .comment-time {
  font-size: 12px;
  color: #888;
  margin-left: 10px;
}
            .gj-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gj-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.gj-detail-card {
  background: rgba(20, 20, 20, 0.6);
  border: 1px solid #2f2f2f;
  border-radius: 12px;
  padding: 14px 16px;
}

.gj-detail-text {
  margin: 0;
  color: #d6d6d6;
  line-height: 1.6;
  overflow-wrap:anywhere;
}

.gj-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.gj-muted {
  color: #9c9c9c;
}

.gj-action-btn {
  background: #ff810e;
  color: #FFF;
  border: none;
  padding: 8px 18px;
  font-family: 'Barlow Condensed', sans-serif;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  clip-path: polygon(5px 0%,100% 0%,calc(100% - 5px) 100%,0% 100%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.gj-action-btn:hover {
  background: #ff810e;
  box-shadow: 0 0 16px rgba(249, 115, 22, 0.45);
}

.gj-action-btn--ghost {
  background: transparent;
  color: #ff810e;
  border: 1px solid rgba(249, 115, 22, 0.5);
  box-shadow: none;
}

.gj-action-btn--ghost:hover {
  background: rgba(249, 115, 22, 0.12);
  box-shadow: none;
}

.gj-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.gj-action-btn--compact {
  padding: 8px 14px;
  font-size: 11px;
}

.gj-comment-submit {
  margin-top: 8px;
  margin-bottom:8px;
}

@media (max-width: 768px) {
  .gj-details-grid {
    grid-template-columns: 1fr;
  }

  .gj-detail-card {
    padding: 12px;
  }
}
            .comment-footer {
  text-align: center;   /* center horizontally */
}

.load-more {
  display: inline-block;
  margin-top: -2px;     /* your requirement */
  cursor: pointer;
  color: #ff810e;
  font-weight: 500;
  text-decoration: underline;
}

.load-more:hover {
  text-decoration: underline;
}
   .comment-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #3d3d3d;
  padding: 10px;
}

.comment-item {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #3d3d3d;
}

.comment-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.comment-content {
  flex: 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comment-name {
  font-weight: bold;
//   overflow:hidden;
//   text-overflow:ellipsis;
//   white-space:nowrap;
}

.comment-text {
  margin: 5px 0 0;
  overflow-wrap:anywhere;
}

.delete-btn {
  background: none;
  border: none;
  color: #ff810e;
  cursor: pointer;
}

.load-more-btn {
//   width: 100%;
//   padding: 8px;
  margin-top: 10px;
  background-color:#ff810e;
}
            .gj-error {
          color: var(--main-color-one);
          font-size: 12px;
          margin-top: 6px;
          margin-bottom: 6px;

        }
                        .gj-register-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 16px;
        }
        .gj-btn {
          border: none;
        //   padding: 12px 14px;
          padding: 8px 8px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 1px;
          cursor: pointer;
        }
        .gj-btn.primary {
          background: var(--main-color-one);
          color: var(--color-back);
        }
        .gj-btn.ghost {
          background: transparent;
          border: 1px solid var(--main-color-two);
          color: var(--main-color-two);
        }
                .tour-detail-pad-left {
                    padding-left: 20px !important;
                }

                .tour-detail-left-line {
                    border-left: 5px solid #ff810e !important;
                }

                .tour-detail-small-text {
                    font-size: 13px !important;
                    opacity: 0.7 !important;
                }
                #iframe-div {
                    display: none;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    background: #000;
                    position: relative;
                }

                #game_frame {
                    width: 100%;
                    border: none;
                }

                #img_frame {
                    width: 100%;
                    height: auto;
                }

                .float_button_visibility {
                    display: flex !important;
                    visibility: visible !important;
                    z-index: 9999 !important;
                    pointer-events: auto !important;
                    opacity: 0.8 !important;
                }

                .fullscreen_manager {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 100vw !important;
                    height: 100vh !important;
                    height: 100dvh !important;
                    z-index: 9999 !important;
                    background: #000 !important;
                    overflow: hidden !important;
                }

                @media (max-width: 768px) {
                    #iframe-div {
                        border-radius: 0;
                    }
                    
                    #game_frame {
                        border-radius: 0;
                    }
                }
                .rotate-overlay {
    position: fixed;
    inset: 0;
    background: #000 !important;
    display: none;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 10000;
}

.rotate-overlay.show {
    display: flex;
}

.rotate-box {
    color: #fff;
    font-size: 20px;
}

            `}</style>
        </>
    );
}
const formatTime = (date) => {
  const now = new Date();
  const commentTime = new Date(date);

  const diff = Math.floor((now - commentTime) / 1000);

  if (diff < 60) return "Just now";
  if (diff < 3600) return Math.floor(diff / 60) + " min ago";
  if (diff < 86400) return Math.floor(diff / 3600) + " hr ago";

  return commentTime.toLocaleDateString();
};

const formatRemaining = (ms) => {
  if (!Number.isFinite(ms) || ms <= 0) return "0:00";
  const totalSec = Math.ceil(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${String(sec).padStart(2, "0")}`;
};

const OpenModal = () => {
    if (window.UIkit && typeof window.UIkit.modal === "function") {
        window.UIkit.modal("#modal-login", { container: false }).show();
    }
};
